import React, { FC, useCallback, useEffect, useMemo } from 'react';

import {
  closeModalByName,
  Modal, ModalProps, openModalByName, PrimaryButton, useScopedSelector,
} from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as animationData from '../../assets/welcome-modal-animation.lottie.json';
import { StyledActionBar, StyledBackgroundDiv, StyledDiv, StyledTitle, StyledList, StyledText, StyledLottie } from './ClientWelcomeModal.styles';
import { Notification } from '../../interfaces/Notification';
import isClientSpacePromotionId from '../../utils/isClientSpacePromotionId';
import { removeNotification, setIsDeleting } from '../../actions/Notifications.actions';
import putReminder from '../../utils/putReminder';

export interface ClientWelcomeModalProps extends ModalProps {
}

const ClientWelcomeModal: FC<ClientWelcomeModalProps> = ({ ...props }) => {
  const { t } = useTranslation('ClientWelcomeModal');
  let promotions: Notification[] = useScopedSelector('/App.features.notifications.promotions', []);
  promotions = useMemo(() => promotions?.filter((notification) => notification.id === 'IA_CLIENT_SPACE'), [promotions]);
  const dispatch = useDispatch();

  const handleDeleted = useCallback(() => {
    promotions?.forEach((notification) => {
      putReminder(notification.id).catch(() => { /* */ });
      dispatch(setIsDeleting(notification.id, true));
      dispatch(removeNotification(notification.id));
    });
  }, [dispatch, promotions]);

  const handleClick = useCallback(() => {
    handleDeleted();
    dispatch(closeModalByName('ClientWelcomeModal'));
  }, [dispatch, handleDeleted]);

  useEffect(() => {
    if (isClientSpacePromotionId(promotions)) {
      dispatch(openModalByName('ClientWelcomeModal'));
    }
  }, [dispatch, promotions]);

  if (!promotions) return null;
  return (
    <Modal {...props} name="ClientWelcomeModal" isClosable nopadding onClose={handleDeleted}>
      <StyledBackgroundDiv data-testid="welcomeModalContentBackground">
        <StyledLottie loop={false} data-testid="welcomeModalanimation" animationData={animationData} />
      </StyledBackgroundDiv>

      <StyledDiv>
        <StyledTitle data-testid="welcomeModalTitle">{t('modalTitle')}</StyledTitle>
        <StyledText data-testid="welcomeModalIntro">{t('modalText')}</StyledText>
        <StyledList data-testid="welcomeModalData">
          <li>{t('modalLineText1')}</li>
          <li>{t('modalLineText2')}</li>
          <li>{t('modalLineText3')}</li>
          <li>{t('modalLineText4')}</li>
        </StyledList>
        <StyledActionBar>
          <PrimaryButton data-testid="exploreButton" onClick={handleClick}>{t('exploreButton')}</PrimaryButton>
        </StyledActionBar>
      </StyledDiv>
    </Modal>
  );
};

export default ClientWelcomeModal;
